import React from 'react';
import PropTypes from 'prop-types';
import {ThemeContext, RadioButton} from '../../../common';

const QuestionAnswer = (props) => {
  const {id, text, disabled, onAnswerSelected, className, isCorrect, isVideoPlaying} = props;

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const {primaryColor, secondaryColor} = theme;
        const borderColor = isCorrect ? secondaryColor : primaryColor;

        return (
          <RadioButton
            label={text}
            className={className}
            containerStyle={{borderColor}}
            circleStyle={{backgroundColor: primaryColor}}
            disabled={disabled || isVideoPlaying}
            onChange={onAnswerSelected}
            name="answer"
            value={id}
          />
        );
      }
      }
    </ThemeContext.Consumer>
  );
};

QuestionAnswer.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  isCorrect: PropTypes.bool.isRequired,
  isVideoPlaying: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onAnswerSelected: PropTypes.func.isRequired,
};

export default QuestionAnswer;
